const getServices = state => state.serviceList;

export default {
  getServices
};



// WEBPACK FOOTER //
// ./src/store/modules/services/getters.js